export default __webpack_public_path__ + "static/media/Credit-EN.c6a2341e.png";